import Component, { mixins } from 'vue-class-component'
import MixinStock from '@mixins/stock'
import stockItem from '../item/index.vue'
import { StockEnzyme } from '@/interfaces/stock'

@Component({
  components: {
    'vgb-stock-item': stockItem,
  },
})
export default class Enzymes extends mixins(MixinStock) {
  get sortedStockEnzymes() {
    return this.stockEnzymes
      .pluck('column')
      .unique()
      .transform((item) => {
        return this.stockEnzymes.filter((enzyme: StockEnzyme) => enzyme.column === item)
      })
  }
}
